<template>
  <div class='container'>


    <div>

      <img class='title' src="../assets/image/title.png" alt="" />

      <div class="text1" v-if="language === 'TC'">
        NIKE步態掃描服務解析您獨一無二的步態找到最適合您的NIKE跑鞋
      </div>
      <div class="text2" v-else>
        NIKE Foot Scan Test analyzes your unique foot pattern to find the most suitable NIKE running shoes for you.
      </div>
      

      <div class='bottom-box'>

        <div class="agree-box" :class="{en: language=== 'EN'}">
          <div @click="agree1 = !agree1">
            <img src="../assets/image/check.png" v-if="agree1" alt="">
          </div>
          <span>{{ language === 'TC' ? '我已年滿 18 歲或以上' : 'I am 18 years of age or older' }}</span>
        </div>

        <div class="agree-box box2" :class="{en: language=== 'EN'}">
          <div @click="agree2 = !agree2">
            <img src="../assets/image/check.png" v-if="agree2" alt="">
          </div>
          <span v-if="language === 'TC'" @click="toDisclaim">我同意《NIKE個資聲明》及《免責同意書》。</span>
          <span v-else @click="toDisclaim">I agree to the NIKE Personal Data Statement and Disclaimer.</span>
        </div>

        <div class='btn' :class="{ disabled: !agree1 || !agree2, en: language === 'EN' }" @click="toForm">{{language === 'TC' ? '開始' : 'Start'}}</div>

      </div>


      
    </div>

    
    
   
    
  </div>
</template>

<script>
  import axios from 'axios'


  export default {
    data () {
      return {
        agree1: false,
        agree2: false,      
      }
    },
    mounted(){

    },
    methods:{

      toDisclaim() {
        this.$router.push({ path: "/disclaim" })
      },

      toForm() {
        if (this.agree1 && this.agree2) {
          this.$router.replace({ path: "/form" })
        }
        
      },
      
    },

    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      openid() {
        return this.$store.state.openid
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },

    },

  }
</script>


<style lang="less" scoped>

  .title {
    position: absolute;
    top: 50vw;
    left: 8vw;
    width: 84vw;
  }

  .text1 {
    position: absolute;
    top: 70vw;
    left: 12.8vw;
    width: 74.6vw;
    font-size: 4vw;
    line-height: 6vw;
    font-weight: 500;
    text-align: center;
    font-family: 'en-bold';
    // font-family: 'fs-regular';
  }

  .text2 {
    position: absolute;
    top: 70vw;
    left: 8vw;
    width: 84vw;
    font-size: 3.8vw;
    line-height: 6vw;
    font-weight: 500;
    text-align: center;
    font-family: 'en-bold';
  }


  .bottom-box {
    position: absolute;
    width: 100%;
    z-index: 10;
    left: 0;
    bottom: 8vw;

    .agree-box {
      display: flex;
      font-size: 3.5vw;
      margin-left: 8vw;
      margin-bottom: 2vw;
      align-items: center;
      font-family: 'en-bold', 'fs-medium';
      &.en {
        font-family: 'en-bold';
      }
      &.box2 {
        margin-bottom: 6vw;
      }

      div {
        position: relative;
        width: 4vw;
        height: 4vw;
        border: 1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 3.5vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
    }

    .btn {
      display: block;
      width: 87.2vw;
      height: 10.67vw;
      margin: 0 auto;
      text-align: center;
      line-height: 10.67vw;
      font-size: 3.7vw;
      color: #000;
      background-color: #fff;
      border-radius: 100px;
      font-weight: bold;
      font-family: 'fs-bold';
      &.en {
        font-family: 'en-bold';
      }
      &.disabled {
        opacity: 0.3;
      }
    }


  }

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }


</style>



// WEBPACK FOOTER //
// src/pages/index.vue